export const AUTHENTICATION_SOURCES = Object.freeze({
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
    FORGOT_PASSWORD: 'forgot-password',
    REFRESH_AUTH_TOKEN: 'refresh-auth-token'
});

export const TOKEN_TYPE = Object.freeze({
    GUEST: 'guest',
    USER: 'user'
});

export const COOKIES_NAMES = Object.freeze({
    AUTH_TOKEN: 'elc-auth-token',
    AUTH_TYPE: 'elc-auth-token-type'
});

export const FAIL_LOGIN_ATTEMPT = Object.freeze({
    BAD_CREDENTIALS: 'bad_credentials',
    CAPTCHA: 'bad_credentials_captcha',
    WARNING: 'bad_credentials_warning',
    FIRST_LOCK: 'locked_user_1st',
    SECOND_LOCK: 'locked_user_2nd'
});

export const OPT_IN_SOURCE = Object.freeze({
    SIGN_IN: 'sign-in'
});
